export default "__VITE_ASSET__Dk57Xckf__"